import { TaskDefinition } from 'src/pages/ClinicalTrial/Readings/TaskDefinition/TaskDefinition';
import { ReadingInventory } from 'src/pages/ClinicalTrial/Readings/ReadingInventory/ReadingInventory';
import { Navigate } from 'react-router-dom';
import { ClinicalTrialInventoryTable } from 'src/pages/ClinicalTrial/Readings/ReadingInventory/components/ClinicalTrialInventoryTable';
import { ReadingInventoryItemForm } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/ReadingInventoryItemForm';

export const readingInventorySubRoutes = [
  {
    title: 'Scoring Forms',
    path: 'scoring-forms',
    key: 'scoringForms',
    element: <ClinicalTrialInventoryTable type={'scoringForms'} />,
  },
  {
    title: 'Instruments',
    path: 'instruments',
    key: 'instruments',
    element: <ClinicalTrialInventoryTable type={'instruments'} />,
  },
  {
    title: 'Measurements',
    path: 'measurements',
    key: 'measurements',
    element: <ClinicalTrialInventoryTable type={'measurements'} />,
  },
  {
    title: 'Functions',
    path: 'functions',
    key: 'functions',
    element: <ClinicalTrialInventoryTable type={'functions'} />,
  },
  {
    title: 'Report Templates',
    path: 'report-templates',
    key: 'reportTemplates',
    element: <ClinicalTrialInventoryTable type={'reportTemplates'} />,
  },
  {
    title: 'Tags',
    path: 'tags',
    key: 'tags',
    element: <ClinicalTrialInventoryTable type={'tags'} />,
  },
  {
    title: 'Readers',
    path: 'readers',
    key: 'readers',
    element: <ClinicalTrialInventoryTable type={'readers'} />,
  },
  {
    title: 'Dictionaries',
    path: 'dictionaries',
    key: 'dictionaries',
    element: <ClinicalTrialInventoryTable type={'dictionaries'} />,
  },
  {
    path: ':itemType/:itemId',
    element: <ReadingInventoryItemForm />,
  },
];

export const readingsSubRoutes = [
  {
    title: 'Tasks Definition',
    path: 'task-definition',
    element: <TaskDefinition />,
  },
  {
    title: 'Inventory',
    path: 'reading-inventory',
    element: <ReadingInventory />,
    children: [
      {
        path: '',
        element: <Navigate to='scoring-forms' replace />,
      },
      ...readingInventorySubRoutes,
    ],
  },
];
